import React, { useState, useRef, useEffect, useContext } from "react";
import styled from "styled-components";
import { GoHome, GoHomeFill } from "react-icons/go";
import { IoSettingsOutline, IoSettingsSharp } from "react-icons/io5";
import { TbSettings, TbShoppingCartFilled } from "react-icons/tb";
import {
  RiHome2Line,
  RiHome5Line,
  RiShoppingBag2Fill,
  RiShoppingBagLine,
} from "react-icons/ri";
import { FaAddressCard, FaRegAddressCard } from "react-icons/fa";
import Context from "../../../Context";
import goTo from "../../../controllers/goTo";
import { MdOutlineShoppingCart } from "react-icons/md";
import { BiHomeAlt, BiHomeAlt2, BiHomeCircle } from "react-icons/bi";
import { FiHome } from "react-icons/fi";
import { LuLayoutDashboard } from "react-icons/lu";
import { GrHomeRounded } from "react-icons/gr";

const TabContainer = styled.div`
  display: flex;
  position: relative;

  /* width: 100%; */
  /* width: fit-content; */
  flex-direction: row;
  /* height: 388px; */

  width: 370px;
  height: 65px;

  border: 1px solid var(--border);
  background: var(--surface);
  overflow: hidden;
  border-radius: 10px;

  @media (max-width: 900px) {
    width: 350px;
    height: 51px;
  }
`;

const Tabs = styled.div`
  display: flex;
  position: absolute;
  right: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  top: 0;
  /* width: 100%; */
  /* width: fit-content; */
  flex-direction: row;
  /* gap: 20px; */
  z-index: 10;
  gap: 0;
  justify-content: flex-start;
`;

const Tab = styled.div`
  position: relative;
  cursor: pointer;
  font-size: 25px;
  display: flex;
  gap: 10px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* width: 100%; */

  animation: all 0.6s ease-in;
  color: var(--element);
  padding: 15px 25px;
  transform: scale(1);
  transition: 0.15s ease-in-out;
  /* 
  ${({ $active }) => {
    if ($active) {
      return `
       color: var(--accentAlt);
      `;
    }
  }} */

  &:hover {
    /* background: var(--surface); */
    /* color: var(--element); */
    transform: scale(0.94);
  }
`;

const Icon = styled.div`
  /* height: 25px; */
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  /* margin-right: 10px; */
`;

const Text = styled.div`
  font-size: 15.5px;
  font-weight: 600;
  white-space: nowrap;
`;

const Pill = styled.div`
  position: absolute;
  /* right: -10px; */
  left: ${({ left }) => `${left}px`};
  /* top: ${({ top }) => `${top + 16}px`}; */
  /* height: ${({ height }) => `${height - 36}px`}; */
  width: ${({ width }) => `${width}px`};
  height: 100%;
  /* width: 10%; */
  /* background-color: var(--accent); */
  /* background: var(--mainGradient); */
  background-color: var(--element);
  /* border-radius: 15px; */

  transition: all 0.3s ease;
  z-index: 2;
  transform: scaleY(0.7) scaleX(0.65) translateY(63px);
  border-radius: 10px;

  /* transform: scaleX(0.4) translateY(55px);
  height: 14px;
  border-radius: 100px; */
  /* filter: blur(20px); */
  /* transform: scale(0.7); */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const Badge = styled.div`
  border-radius: 100px;
  right: 35px;
  top: 5px;
  position: absolute;
  font-size: 13px;
  font-weight: 700;
  padding: 6px 9px;
  background-color: var(--headerAccent);
  color: var(--headerAccentAlt);
`;

const NavBar = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { currentRoute, loggedInUser } = useContext(Context);
  const [shouldShow, setShouldShow] = useState(false);
  const [pillStyle, setPillStyle] = useState({ left: 0, width: 0 });
  const tabRefs = useRef([]);

  const tabs = [
    {
      label: "",
      // icon: <GoHomeFill />,
      icon: <BiHomeAlt />,
      link: "/",
    },
    {
      label: "",
      // icon: <FaAddressCard />,
      icon: <FaRegAddressCard />,
      link: "/membership",
    },
    {
      label: "",
      // icon: <RiShoppingBag2Fill />,
      icon: <RiShoppingBagLine />,
      link: "/shopping",
    },
    {
      label: "",
      // icon: <TbShoppingCartFilled />,
      icon: <MdOutlineShoppingCart />,
      link: "/cart",
      badgeCount: getTotalCartItems(),
    },
    {
      label: "",
      // icon: <IoSettingsSharp />,
      icon: <TbSettings />,
      link: "/settings",
    },
  ];

  useEffect(() => {
    console.log("currentRoute", currentRoute);
    let currentPath = window.location.pathname;
    let pathNameAndSearch = currentPath + window.location.search;

    console.log("pathname", currentPath, pathNameAndSearch);

    if (currentPath === "/") {
      setShouldShow(true);
    } else {
      let shouldShowVal = false;
      let i = 0;
      for (let item of tabs) {
        if (item.link == currentPath || item.link == pathNameAndSearch) {
          shouldShowVal = true;
          setActiveIndex(i);
        }
        i++;
      }

      console.log("currentPath", currentPath, currentRoute, shouldShowVal);

      setShouldShow(shouldShowVal);
    }
  }, [currentRoute]);

  useEffect(() => {
    const currentTab = tabRefs.current[activeIndex];
    if (currentTab) {
      setPillStyle({
        top: currentTab.offsetTop,
        left: currentTab.offsetLeft,
        height: currentTab.offsetHeight,
        width: currentTab.offsetWidth,
      });
    }
  }, [activeIndex]);

  const handleTabClick = (index) => {
    setShouldShow(true);
    setActiveIndex(index);
    goTo(tabs[index].link)();
  };

  return (
    <TabContainer>
      <Tabs>
        {tabs.map((item, index) => (
          <Tab
            style={item.style}
            key={item.label}
            $active={index === activeIndex && shouldShow}
            onClick={() => handleTabClick(index)}
            ref={(el) => (tabRefs.current[index] = el)}
          >
            {item.badge ? <Badge>{item.badge}</Badge> : null}
            {/* Badge is for notifications */}

            {item.icon && <Icon>{item.icon}</Icon>}
            {item.label && <Text>{item.label}</Text>}
          </Tab>
        ))}
      </Tabs>

      {shouldShow ? (
        <Pill
          top={pillStyle.top}
          left={pillStyle.left}
          height={pillStyle.height}
          width={pillStyle.width}
        />
      ) : null}
    </TabContainer>
  );

  function getTotalCartItems() {
    if (!loggedInUser.cart) return 0;

    let totalItems = 0;

    for (let itemID in loggedInUser.cart) {
      let item = loggedInUser.cart[itemID];
      totalItems += item.quantity;
    }

    return totalItems;
  }
};

export default NavBar;
